import React from "react";
import { FaImage, FaUpload } from "react-icons/fa";

function SkeletonCard() {
  return (
    <section className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="h-1.5 bg-gradient-to-r from-[#013E8E] via-indigo-500 to-[#4CA82F]" />

      <div className="space-y-4 p-5">
        <div className="h-44 animate-pulse rounded-2xl bg-slate-100 dark:bg-slate-800" />
        <div className="h-12 animate-pulse rounded-2xl bg-slate-100 dark:bg-slate-800" />
      </div>
    </section>
  );
}

export default function PaiementDefaultImageCard({
  imageSrc,
  imageUrl,
  loading,
  onOpenUpload,
}) {
  if (loading) return <SkeletonCard />;

  return (
    <section className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="h-1.5 bg-gradient-to-r from-[#013E8E] via-indigo-500 to-[#4CA82F]" />

      <div className="p-4 sm:p-5 lg:p-6">
        <div className="mb-5 flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between">
          <div>
            <p className="text-[11px] uppercase tracking-[0.22em] text-slate-500 dark:text-slate-400">
              Image par défaut
            </p>

            <h3 className="mt-1 flex items-center gap-2 text-xl font-bold text-slate-900 dark:text-white">
              <FaImage className="text-indigo-600 dark:text-indigo-300" />
              Visuel Licence-Assurance & Cotisation
            </h3>

            <p className="mt-2 text-sm leading-6 text-slate-600 dark:text-slate-300">
              Cette image est utilisée par défaut pour illustrer le règlement ou
              la ligne de cotisation lorsque le club n’a pas défini d’autre
              visuel.
            </p>
          </div>

          <button
            type="button"
            onClick={onOpenUpload}
            className="inline-flex items-center justify-center gap-2 rounded-2xl bg-[#013E8E] px-4 py-3 text-sm font-bold text-white shadow-sm transition hover:bg-[#012f6d] dark:bg-indigo-500 dark:hover:bg-indigo-400"
          >
            <FaUpload />
            Changer l’image
          </button>
        </div>

        <div className="grid gap-5 lg:grid-cols-[280px,1fr]">
          <div className="overflow-hidden rounded-[24px] border border-slate-200 bg-slate-50 p-3 dark:border-slate-800 dark:bg-slate-950">
            <img
              src={imageSrc}
              alt="Image par défaut du règlement"
              className="h-56 w-full rounded-2xl object-cover"
              referrerPolicy="no-referrer"
              crossOrigin="anonymous"
              onError={(event) => {
                event.currentTarget.src = "/img/no-image.jpg";
              }}
            />
          </div>

          <div className="min-w-0 rounded-[24px] border border-slate-200 bg-slate-50 p-4 dark:border-slate-800 dark:bg-slate-950/70">
            <label className="mb-1 block text-sm font-bold text-slate-700 dark:text-slate-200">
              URL actuelle
            </label>

            <input
              type="text"
              value={imageUrl || ""}
              readOnly
              onFocus={(event) => event.target.select()}
              placeholder="Aucune image personnalisée"
              className="w-full cursor-text rounded-2xl border border-slate-200 bg-white px-3 py-2.5 text-sm font-medium text-slate-700 outline-none transition placeholder:text-slate-400 focus:ring-2 focus:ring-indigo-400 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200"
            />

            <p className="mt-2 text-xs leading-5 text-slate-500 dark:text-slate-400">
              Formats acceptés : PNG, JPG, WEBP. Taille maximale : 10 Mo.
              WEBP est recommandé pour de meilleures performances.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}